import { object } from 'yup'

export default object({
  image1: object().notRequired(),
  image2: object().notRequired(),
  image3: object().notRequired()
})
